module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAABWUlEQVQ4jY2SzUrDQBSFr6EBcVOQ7ly77MIXcNNld4L4CH0G1258BN34Etf+kASkkNVQIWWYFmoKI3TAVmoo2NYkMNeNKaFN7Ry4m7P47sw5F4gIiAgYY63hcPjueV4j80wGiAiklF/0pzRNCRGPjQHdbveetiSECI0BnPPBNoCIyHXdayNAEASvRYDVaqUR8fQQwIqiCKFAlmUV2btCxBOt9WZzmqYkpYw6nc6lcQv9fj/IAEmSULPZPDMN0QIAmEwmda01AADYtg3VanVg9n6ADcn3/cd8iOPx+DO/qdfrvXDORbvdvtj5Qjacc5GHSCkjRLR833/IvDiOiTH2XAggIhiNRioPmc1m8XK51LQlpdS367o3hcEIId52DqNA8/k82ZsuY6x1CDCdTn/+rchxnKswDD/2ATzPaxwR0cGmHMepVyqV23K5fF4qlez1er1QSt3VarWnX1TPyPE9ncKNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneicon-1.png
// module id = 41jG
// module chunks = 52